howspace.automation = (() => {
    'use strict';

    const enableSaveButton = modal => {
        let requiredInputs = modal.find('input[name="name"], .action-list .action-item [required], .frequency-select:visible').filter(function () {
            return $(this).closest('.trigger-arguments-collapse, .action-params-collapse').length === 0;
        });

        const selectedTriggerItem = modal.find('.trigger-item[aria-selected="true"]');
        const triggerArgsCollapse = selectedTriggerItem.find('.trigger-arguments-collapse');
        requiredInputs = requiredInputs.add(triggerArgsCollapse.find('input[required], select[required]'));

        modal.find('.action-list .action-item').each(function () {
            const action = $(this);
            requiredInputs = requiredInputs.add(action.find('input[required], select[required]'));
        });

        let disabled = false;
        if (selectedTriggerItem.length === 0) {
            disabled = true;
        }
        if (modal.find('.action-list .action-item').length === 0) {
            disabled = true;
        }
        requiredInputs.each(function () {
            const input = $(this);
            if (!input.val()) {
                disabled = true;
                return false;
            }
        });

        if (modal.find('.alert-warning:visible').length > 0) {
            disabled = true;
        }

        if (selectedTriggerItem.length && selectedTriggerItem.data('type') === 'scheduled') {
            const frequencyVal = modal.find('.frequency-select').val();
            if (!frequencyVal) {
                disabled = true;
            }
        }

        modal.find('.modal-footer .btn-success').prop('disabled', disabled);
    };

    const attachFormEvents = modal => {
        enableSaveButton(modal);

        modal.on('input', 'input[required]', () => {
            enableSaveButton(modal);
        });

        modal.on('input', 'select[required]:visible', () => {
            enableSaveButton(modal);
        });

        modal.on('click', '.delete-btn', e => {
            const card = $(e.currentTarget).closest('.action');
            howspace.components.collapse.collapse(card.find('.card-title'));
            enableSaveButton(modal);
        });

        modal.on('click', '.undelete-btn', () => {
            enableSaveButton(modal);
        });

        modal.on(howspace.components.collapse.EXPANDED, '.collapse', () => {
            enableSaveButton(modal);
        });

        modal.on('change', '.action-select', e => {
            const select = $(e.currentTarget);
            const card = select.closest('.card');
            const actions = card.closest('.actions');

            actions.find('.card-title.howspace-collapse-initialized').each(function () {
                howspace.components.collapse.collapse(this);
            });

            howspace.components.collapse.expand(card.find('.card-title'));

            card.find('.action-params-collapse.expanded').each(function () {
                howspace.components.collapse.close($(this));
            });

            const collapse = card.find('#action-params-' + select.val() + '-collapse');
            howspace.components.collapse.open(collapse);
        });

        modal.find('.param-select').on('change', e => {
            const collapse = $(e.currentTarget).closest('.collapse');
            howspace.animate(collapse.find('.param-alert:visible'), 'slideUp');
            enableSaveButton(modal);
        });

        modal.find('.frequency-select').on('change', () => {
            enableSaveButton(modal);
        });

        modal.find('.actions').on(howspace.components.sortableList.ITEM_MOVED, () => {
            let index = 1;
            modal.find('.action').each(function () {
                const action = $(this);
                const title = action.find('.card-title');
                title.html(title.html().trim().replace(/\d+$/, String(index)));
                index++;
            });
        });

        modal.find('.show-action-menu-btn').on('click', () => {
            modal.find('.action-menu').removeClass('d-none');
            modal.find('.action-list').addClass('d-none');
            modal.find('.show-action-menu-btn').attr('aria-expanded', 'true');
            modal.find('.actions-search-input').val('').trigger('input').trigger('focus');
        });

        modal.find('.hide-action-menu-btn').on('click', () => {
            modal.find('.action-menu').addClass('d-none');
            modal.find('.action-list').removeClass('d-none');
            modal.find('.show-action-menu-btn').attr('aria-expanded', 'false');
        });

        modal.find('.add-action-btn').on('click', e => {
            modal.find('.action-menu').addClass('d-none');
            modal.find('.action-list').removeClass('d-none');
            modal.find('.hide-action-menu-btn').removeClass('d-none');
            modal.find('.show-action-menu-btn').attr('aria-expanded', 'false');

            const btn = $(e.currentTarget);
            const action = btn.closest('.action-item');
            const newAction = action.clone();
            newAction.attr('aria-selected', 'true');
            newAction.find('.howspace-text-editor-initialized').removeClass('howspace-text-editor-initialized');
            newAction.find('.howspace-user-picker-initialized').removeClass('howspace-user-picker-initialized');
            newAction.find('.howspace-form-search-label-initialized').removeClass('howspace-form-search-label-initialized');
            newAction.find('.howspace-collapse-initialized').removeClass('howspace-collapse-initialized');
            newAction.find('[aria-controls]').each(function () {
                const control = $(this);
                const oldIds = control.attr('aria-controls').split(' ');
                const newIds = oldIds.map(oldId => {
                    const newId = oldId + '-' + real.uid();
                    newAction.find('#' + oldId).attr('id', newId);
                    return newId;
                });
                control.attr('aria-controls', newIds.join(' '));
            });
            newAction.find('.card').each(function () {
                howspace.components.card.setId($(this));
            });
            howspace.components.init(newAction);
            newAction.removeClass('add-action-btn');

            modal.find('.action-list .show-action-menu-btn').before(newAction);

            const collapse = newAction.find('.action-params-collapse');
            if (collapse.length > 0) {
                collapse.removeClass('d-none');
                howspace.form.focusFirstInput(collapse);
            }

            enableSaveButton(modal);
        });

        modal.find('input[name="target_anonymous_users"]').on('change', e => {
            const checkbox = $(e.currentTarget);
            if (checkbox.is(':checked')) {
                modal.find('input[name="roles"][value="participant"]').prop('checked', true);
                modal.find('input[name="roles"]').not('[value="participant"]')
                    .prop('disabled', true)
                    .closest('label').addClass('disabled');
            } else {
                modal.find('input[name="roles"]').prop('disabled', false)
                    .closest('label').removeClass('disabled');
            }
        });

        modal[0].addEventListener(howspace.components.tab.TAB_SHOWN, e => {
            const tab = e.detail.tab;
            const panelId = tab.attr('aria-controls');
            const tabPanel = modal.find('#' + panelId);

            if (panelId === 'tabpanel-actions') {
                // Components inside .action-params-collapse may have failed to initialize
                // while the panel was hidden (e.g. text editors need a visible element).
                // Re-initialize them now that the panel is visible.
                tabPanel.find('.action-list .action-item .action-params-collapse').each(function () {
                    const collapse = $(this);
                    collapse.find('.howspace-text-editor-initialized').removeClass('howspace-text-editor-initialized');
                    collapse.find('.howspace-user-picker-initialized').removeClass('howspace-user-picker-initialized');
                    collapse.find('.howspace-form-search-label-initialized').removeClass('howspace-form-search-label-initialized');
                    collapse.find('.howspace-collapse-initialized').removeClass('howspace-collapse-initialized');
                    howspace.components.init(collapse);
                });
            }

            if (panelId === 'tabpanel-review') {
                populateReviewTab(modal);
            }

            const previousBtn = modal.find('.previous-btn');
            const nextBtn = modal.find('.next-btn');
            const successBtn = modal.find('.btn-success');

            if (tab.prev('.howspace-tab').length === 0) {
                // first tab
                previousBtn.prop('disabled', true);
                nextBtn.prop('disabled', false);
                nextBtn.removeClass('d-none');
                successBtn.addClass('d-none');
            } else if (tab.next('.howspace-tab').length === 0) {
                // last tab
                previousBtn.prop('disabled', false);
                nextBtn.prop('disabled', true);
                nextBtn.addClass('d-none');
                successBtn.removeClass('d-none');
            } else {
                // in between
                previousBtn.prop('disabled', false);
                nextBtn.prop('disabled', false);
                nextBtn.removeClass('d-none');
                successBtn.addClass('d-none');
            }

            howspace.form.focusFirstInput(tabPanel);
        });

        modal.find('.previous-btn').on('click', () => {
            const selectedTab = modal.find('.howspace-tab[aria-selected="true"]');
            const previousTab = selectedTab.prev('.howspace-tab');

            previousTab.trigger('click');
        });

        modal.find('.next-btn').on('click', () => {
            const selectedTab = modal.find('.howspace-tab[aria-selected="true"]');
            const nextTab = selectedTab.next('.howspace-tab');

            nextTab.trigger('click');
        });

        modal.find('#tabpanel-trigger .howspace-form-search-input').on(howspace.components.searchInput.SEARCH, e => {
            const search = (e.detail.value || '').toLowerCase().trim();
            if (search) {
                modal.find('.trigger-item').each(function () {
                    const item = $(this);
                    if (item.data('keywords').indexOf(search) > -1) {
                        item.removeClass('d-none');
                    } else {
                        item.addClass('d-none');
                    }
                });
            } else {
                modal.find('.trigger-item').removeClass('d-none');
            }
        });

        modal.find('#tabpanel-actions .action-menu .howspace-form-search-input').on(howspace.components.searchInput.SEARCH, e => {
            const search = (e.detail.value || '').toLowerCase().trim();
            if (search) {
                modal.find('.action-item').each(function () {
                    const item = $(this);
                    if (item.data('keywords').indexOf(search) > -1) {
                        item.removeClass('d-none');
                    } else {
                        item.addClass('d-none');
                    }
                });
            } else {
                modal.find('.action-item').removeClass('d-none');
            }
        });

        const scheduleSelect = modal.find('#schedule-select');

        modal.find('.trigger-item').on('click', e => {
            const trigger = $(e.currentTarget);
            modal.find('.trigger-item[aria-selected="true"]').attr('aria-selected', 'false');
            trigger.attr('aria-selected', 'true');
            modal.addClass('has-trigger');

            if (trigger.data('type') === 'scheduled') {
                howspace.form.enable(scheduleSelect);
                modal.find('input[name="run_limit"][value="true"]').prop('checked', true);
            } else {
                scheduleSelect.find('.frequency-select').val(null).trigger('change');
                howspace.form.disable(scheduleSelect);
                modal.find('input[name="run_limit"][value="false"]').prop('checked', true);
            }
            howspace.form.focusFirstInput(trigger);
            enableSaveButton(modal);
        });

        modal.find('.delete-trigger-btn').on('keydown', e => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
                $(e.currentTarget).trigger('click');
            }
        });

        modal.find('.trigger-item').on('keydown', e => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                $(e.currentTarget).trigger('click');
            }
        });

        modal.find('.delete-trigger-btn').on('click', e => {
            const selectedTrigger = modal.find('.trigger-item[aria-selected="true"]');
            selectedTrigger.attr('aria-selected', 'false');
            modal.removeClass('has-trigger');
            howspace.components.scheduleSelect.reset(scheduleSelect);
            howspace.form.disable(scheduleSelect);
            modal.find('input[name="run_limit"][value="false"]').prop('checked', true);
            modal.find('.trigger-search-input').val('').trigger('input').trigger('focus');
            e.stopPropagation();
        });

        modal.on('click', '.edit-action-btn', e => {
            const btn = $(e.currentTarget);
            const action = btn.closest('.action-item');
            const collapse = action.find('.action-params-collapse');
            if (collapse.is(':visible')) {
                howspace.animate(collapse, 'slideUp');
                btn.attr('aria-expanded', 'false');
            } else {
                collapse.find('.howspace-text-editor-initialized').removeClass('howspace-text-editor-initialized');
                collapse.find('.howspace-user-picker-initialized').removeClass('howspace-user-picker-initialized');
                collapse.find('.howspace-form-search-label-initialized').removeClass('howspace-form-search-label-initialized');
                collapse.find('.howspace-collapse-initialized').removeClass('howspace-collapse-initialized');
                howspace.components.init(collapse);
                howspace.animate(collapse, 'slideDown', 350, () => {
                    howspace.form.focusFirstInput(collapse);
                });
                btn.attr('aria-expanded', 'true');
            }
            e.stopPropagation();
        });

        modal.on('click', '.delete-action-btn', e => {
            const btn = $(e.currentTarget);
            const action = btn.closest('.action-item');
            const previousAction = action.prev('.action-item');
            howspace.components.destroy(action);
            action.remove();

            enableSaveButton(modal);

            if (modal.find('.action-list .action-item').length === 0) {
                modal.find('.action-menu').removeClass('d-none');
                modal.find('.action-list').addClass('d-none');
                modal.find('.hide-action-menu-btn').addClass('d-none');
                modal.find('.show-action-menu-btn').trigger('focus');
                modal.find('.actions-search-input').val('').trigger('input').trigger('focus');
            } else if (previousAction.length) {
                previousAction.find('.edit-action-btn, .delete-action-btn').first().trigger('focus');
            } else {
                modal.find('.action-list .action-item').first().find('.edit-action-btn, .delete-action-btn').first().trigger('focus');
            }
            e.stopPropagation();
        });
    };

    const initCreateModal = (modal) => {
        modal = $(modal);

        attachFormEvents(modal);
        enableSaveButton(modal);
        howspace.form.focusFirstInput(modal);

        modal.find('.modal-footer .btn-success').on('click', e => {
            const btn = $(e.currentTarget);
            real.button.loading(btn, modal);

            const dataPayload = getModalPayload(modal);

            real.ajax.json(real.baseUri + '/api/automations', {
                type: 'POST',
                data: JSON.stringify(dataPayload),
                success: () => {
                    howspace.components.modal.close(modal);
                    howspace.components.lister.reload($('.automations-lister'));
                },
                error: () => {
                    real.button.reset(btn, modal);
                }
            });
        });
    };

    const getModalPayload = (modal) => {
        const dataPayload = {
            ...real.form.getDataPayload(modal),
            ...real.form.getDataPayload(modal.find('.trigger-item[aria-selected="true"]'))
        };

        dataPayload.actions = [];

        modal.find('.action-list .action-item').each(function () {
            const action = $(this);
            const type = action.find('input[name="type"]').val();

            dataPayload.actions.push({
                type: type,
                params: real.form.getDataPayload(action.find('.action-params-collapse'))
            });
        });

        if (dataPayload.run_limit === undefined) {
            dataPayload.run_limit = true;
        }

        if (dataPayload.frequency === null) {
            dataPayload.frequency = '';
        }

        if (dataPayload.schedule === null) {
            dataPayload.schedule = '';
        }

        return dataPayload;
    };

    const populateReviewTab = modal => {
        const reviewPanel = modal.find('#tabpanel-review');

        // Trigger summary
        const selectedTrigger = modal.find('.trigger-item[aria-selected="true"]');
        const triggerAlert = reviewPanel.find('.trigger-alert .alert-content');
        if (selectedTrigger.length) {
            const triggerName = selectedTrigger.find('.title').text().trim();
            triggerAlert.html('<strong>' + real.escapeHtml(triggerName) + '</strong>');
        } else {
            triggerAlert.html('<em>' + howspace.translate('workspacesettings_automations_review_no_trigger') + '</em>');
        }

        // Schedule summary
        const scheduleAlert = reviewPanel.find('.schedule-alert .alert-content');
        const frequencySelect = modal.find('.frequency-select');
        const frequencyVal = frequencySelect.val();
        if (frequencyVal) {
            let scheduleText = real.escapeHtml(frequencySelect.find('option:selected').text().trim());

            // The stored schedule is in UTC, so describe it with the browser-local selections the admin made.
            const scheduleDetails = [];
            modal.find('.howspace-schedule-select').find('.weekday-label, .month-label, .time-label').each(function () {
                const label = $(this);
                if (!label.hasClass('d-none')) {
                    scheduleDetails.push(real.escapeHtml(label.find('option:selected').text().trim()));
                }
            });
            if (scheduleDetails.length) {
                scheduleText += ' — ' + scheduleDetails.join(', ');
            }
            const runLimit = modal.find('input[name="run_limit"]:checked').val();
            scheduleText += ' (' + (runLimit === 'true' ? howspace.translate('workspacesettings_automations_review_run_once_per_user') : howspace.translate('workspacesettings_automations_review_run_unlimited')) + ')';
            scheduleAlert.html(scheduleText);
        } else {
            scheduleAlert.html('<em>' + howspace.translate('workspacesettings_automations_review_no_schedule') + '</em>');
        }

        // Actions summary
        const actionsAlert = reviewPanel.find('.actions-alert .alert-content');
        const actionItems = modal.find('.action-list .action-item');
        if (actionItems.length) {
            const actionNames = [];
            actionItems.each(function () {
                const name = $(this).find('.title').text().trim();
                if (name) {
                    actionNames.push(real.escapeHtml(name));
                }
            });
            actionsAlert.html(actionNames.join(', '));
        } else {
            actionsAlert.html('<em>' + howspace.translate('workspacesettings_automations_review_no_actions') + '</em>');
        }

        // Audience summary
        const audienceAlert = reviewPanel.find('.audience-alert .alert-content');
        const rolesChecked = modal.find('input[name="roles"]:checked');
        let audienceText = '';
        if (rolesChecked.length) {
            audienceText = rolesChecked.closest('label').text().trim();
        }
        const targetAnonymous = modal.find('input[name="target_anonymous_users"]').is(':checked');
        if (targetAnonymous) {
            audienceText += (audienceText ? ' + ' : '') + howspace.translate('workspacesettings_automations_review_audience_anonymous_users');
        }

        // Last seen
        const lastSeenToggle = modal.find('[aria-controls="last-seen-collapse"]');
        if (lastSeenToggle.length && lastSeenToggle.attr('aria-expanded') === 'true') {
            const lastSeenCollapse = modal.find('#last-seen-collapse');
            const notVisitedRadio = lastSeenCollapse.find('#target-not-visited-days-radio:checked');
            const notVisitedVal = lastSeenCollapse.find('#target-not-visited-days-input').val();
            const visitedRadio = lastSeenCollapse.find('#target-visited-days-radio:checked');
            const visitedVal = lastSeenCollapse.find('#target-visited-days-input').val();
            if (notVisitedRadio.length) {
                audienceText += (audienceText ? ' + ' : '') + howspace.translate('workspacesettings_automations_review_audience_have_not_visited', {'days': real.escapeHtml(notVisitedVal)});
            }
            if (visitedRadio.length) {
                audienceText += (audienceText ? ' + ' : '') + howspace.translate('workspacesettings_automations_review_audience_have_visited', {'days': real.escapeHtml(visitedVal)});
            }
        }

        // User lists
        const userlistToggle = modal.find('[aria-controls="userlist-collapse"]');
        if (userlistToggle.length && userlistToggle.attr('aria-expanded') === 'true') {
            const userlistCollapse = modal.find('#userlist-collapse');
            const selectedLists = userlistCollapse.find('input:checked');
            if (selectedLists.length) {
                const listNames = [];
                selectedLists.each(function () {
                    const name = $(this).next('.howspace-form-label-text').text().trim();
                    if (name) {
                        listNames.push(real.escapeHtml(name));
                    }
                });
                if (listNames.length) {
                    audienceText += (audienceText ? ' + ' : '') + howspace.translate('workspacesettings_automations_review_audience_userlists') + ': ' + listNames.join(', ');
                }
            }
        }

        audienceAlert.html(audienceText || '<em>' + howspace.translate('workspacesettings_automations_review_no_audience') + '</em>');
    };

    return {
        initCreateModal: initCreateModal,
        attachFormEvents: attachFormEvents,
        getModalPayload: getModalPayload
    }
})();
